/* eslint-disable */
import React, { useMemo, useState } from 'react';
import ImgPoint from '../../../../../../assets/2025/arrow.gif';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import elePerson_2_1 from '../../../../../../assets/2025/topic900/elePerson_2_1.png';
import elePerson_2_3 from '../../../../../../assets/2025/topic900/elePerson_2_3.png';
import elePerson_2_2 from '../../../../../../assets/2025/topic900/elePerson_2_2.png';
import elePerson_2_4 from '../../../../../../assets/2025/topic900/elePerson_2_4.png';
import pwd_type_3_1 from '../../../../../../assets/2025/topic900/pwd_type_3_1.png';
import pwd_type_3_4 from '../../../../../../assets/2025/topic900/pwd_type_3_4.png';
import pwd_type_3_4_1 from '../../../../../../assets/2025/topic900/pwd_type_3_4_1.png';
import pwd_type_3_3 from '../../../../../../assets/2025/topic900/pwd_type_3_3.png';
import back_1_3_m from '../../../../../../assets/2025/topic900/back_1_3_m.png';
import pwd_type1 from '../../../../../../assets/2025/topic900/pwd_type1.png';
import pwd_type2 from '../../../../../../assets/2025/topic900/pwd_type2.png';
import en_img from '../../../../../../assets/2025/topic900/en_img.png';
import { useUpdateComponentState } from '../../../hooks';

interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const { updateParagraphState } = useStore();
  const ap_videoRef =
    React.useRef() as React.MutableRefObject<HTMLVideoElement>;
  const ap_videoContainerRef =
    React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const [state, setState] = React.useState({
    step: 0,
  });
  const updateComponentState = useUpdateComponentState()
//设置密码图片状态用于点击翻转
  const [pwdStatus, setPwdStatus] = useState<number>(0);
  const [pwdIndex, setPwdIndex] = useState<boolean[]>([false, false, false, false]);
  const handleClickPwd = (index: number) => {
    if(index===pwdStatus){
      const newItems = [...pwdIndex];
      newItems[index] = true;
      setPwdIndex(newItems);
      setPwdStatus(++index);
    }
  };

  React.useEffect(() => {
    if (pwdStatus===4) {
      updateComponentState(p_course, p_topic, ID,'2025-topic900-section1-1')
      // updateParagraphState(p_course, p_topic, ID, 'completed', []);
    }
  }, [
    p_course,
    p_topic,
    pwdStatus,
    updateParagraphState,
  ]);
  return (
    <div className="topic-section-1">
        <div className="padding_box">
          <div className="header_box">
            <h1 className="header">{paragraphsSettings?.title}</h1>
          </div>
          <div className="title_box_m">
            <div className="header">{paragraphsSettings?.l1}</div>
            <div className="header_r_text" dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.l2,
            }}></div>
          </div>
          <div className="example">
              <div className="example_box_1">
                  <div className="title_box">
                      <div className="text">{paragraphsSettings?.l3}</div>
                  </div>
                  <div className="text1"
                       dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.l4,
                  }}/>
                  <div className="text2">
                      <span>{paragraphsSettings?.l4t}</span>
                  </div>
                  <a href={paragraphsSettings?.l4a} className="text_a" target="_blank">{paragraphsSettings?.l4a2}</a>
              </div>
          </div>
      </div>

      <div className="t900_custom">
        <div className="padding_box" style={{paddingBottom: '4rem'}}>
          <div className="title_box_m">
            <div className="header">{paragraphsSettings?.btitle}</div>
            <span>{paragraphsSettings?.bl3}</span>
          </div>
          <div className="ele_person_box">
            <div className="left">
              <img src={elePerson_2_1} className="ele_l1" />
              <img src={elePerson_2_3} className="ele_l2" />
              <div className="text_position">
                <p>{paragraphsSettings?.bl4}</p>
                <p>{paragraphsSettings?.bl401}</p>
              </div>
            </div>
            <div className="right">
              <img src={elePerson_2_2} className="ele_l1"/>
              <img src={elePerson_2_4} className="ele_l2"/>
              <div className="text_position">
                <p>
                  <span  className="l2">{paragraphsSettings?.bl500}</span>
                  <span className="l1">{paragraphsSettings?.bl5}</span>
                </p>
                <p className="l1">{paragraphsSettings?.bl501}</p>
                <i/>
              </div>
            </div>
          </div>
        </div>
        <div className="padding_box" style={{paddingBottom: '4rem'}}>
          <div className="example_box_2">
            <div className="back_line2"></div>
            <p className="title_t">{paragraphsSettings?.l5}</p>
            <div className="tips_box" dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.l6,
            }}/>
            <div className="content_box en_hide">
                <i className="line line1"></i>
                <i className="line line2"></i>
                <i className="line line3"></i>
                <i className="line line4"></i>
                <i className="line line5"></i>
                <div className="item_group" style={{width:'11%'}}>
                  <div className="title_box" style={{background:"#0B52A2",color:"#fff"}}>{paragraphsSettings?.c1}</div>
                  {paragraphsSettings?.c1Array.map((item:string,index: number)=>{
                    return <div className="item" key={index}>{item}</div>
                  })}
                </div>
                <div className="item_group" style={{width:'11%'}}>
                  <div className="title_box" style={{background:"#4D84C5",color:"#fff"}}>{paragraphsSettings?.c2}</div>
                  {paragraphsSettings?.c2Array.map((item:string,index:number)=>{
                    return <div className="item" key={index}>{item}</div>
                  })}
                </div>
                <div className="item_group" style={{width:'15%'}}>
                  <div className="title_box" style={{background:"#95C6F7",color:"#000"}}>{paragraphsSettings?.c3}</div>
                  {paragraphsSettings?.c3Array.map((item:string,index:number)=>{
                    return <div className="item" key={index}>{item}</div>
                  })}
                </div>
                <div className="item_group" style={{width:'15%'}}>
                  <div className="title_box" style={{background:"#BBDCFF",color:"#000"}}>{paragraphsSettings?.c4}</div>
                  {paragraphsSettings?.c4Array.map((item:string,index: number)=>{
                    return <div className="item" key={index}>{item}</div>
                  })}
                </div>
                <div className="item_group" style={{width:'22%'}}>
                  <div className="title_box" style={{background:"#DEE3FC",color:"#000"}}>{paragraphsSettings?.c5}</div>
                  {paragraphsSettings?.c5Array.map((item:string,index: number)=>{
                    return <div className="item" key={index}>{item}</div>
                  })}
                </div>
                <div className="item_group" style={{width:'27%'}}>
                  <div className="title_box" style={{background:"#8C8EE8",color:"#fff"}}>{paragraphsSettings?.c6}</div>
                  {paragraphsSettings?.c6Array.map((item:string,index:number)=>{
                    return <div className="item" key={index}>{item}</div>
                  })}
                </div>
            </div>
            <img src={en_img} className="en_pirce"  style={{'display':'none'}} alt="" />
          </div>
        </div>
        <div id="2025-topic900-section1-1" className="padding_box" style={{paddingBottom: '5rem'}}>
          <div className="title_box_m">
            <div className="header">
              {paragraphsSettings?.bl11}
              {paragraphsSettings?.l12}
            </div>
            <span>{paragraphsSettings?.bl13}</span>
          </div>
          <div className="flex_c mobile_hide">
            <div className="back_1_3">
              <div className="title_box">
                <span>{paragraphsSettings?.bl18}</span>
                <i className="arrow_r"/>
              </div>
              <span
                className="content"
                dangerouslySetInnerHTML={{
                  __html: paragraphsSettings?.bl14,
                }}
              />
              <div className="pwd_img_box">
                <div className={`img_type1 pwd_img1 ${pwdIndex[0] ? 'active' : ''}`} onClick={() => {handleClickPwd(0);}}>
                  <img src={ImgPoint} alt="" className="arrow_icon"
                       style={{display: (pwdStatus === 0 && pwdIndex[0] === false) ? 'block' : 'none'}}
                  />
                  <p className="pwd_title type1">{paragraphsSettings?.bl17}</p>
                  <div className="pwd_mmsy type2">{paragraphsSettings?.bl15}</div>
                  <div className="pwd_text_box type1">
                    <p>{paragraphsSettings?.bl49}</p>
                    <p>{paragraphsSettings?.bl49a}</p>
                  </div>
                  <div className="pwd_text_box type2">
                    <p  dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.bl22,
                    }}></p>
                  </div>
                  <img src={pwd_type_3_1} alt="" className="type1"/>
                  <img src={pwd_type_3_4} alt="" className="type2"/>
                  <span className="pwd_mima type1">{paragraphsSettings?.bl49b}</span>
                  <div
                    className="pwd_wb_box type1"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.bl21,
                    }}
                  />
                  <div
                    className="pwd_wb_box type2"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.bl23,
                    }}
                  />
                </div>

                <div className={`img_type1 pwd_img2 ${pwdIndex[1] ? 'active' : ''}`} onClick={() => {handleClickPwd(1);}}>
                  <img src={ImgPoint} alt="" className="arrow_icon"
                       style={{display: (pwdStatus === 1 && pwdIndex[1] === false) ? 'block' : 'none'}}
                  />
                  <p className="pwd_title type1">{paragraphsSettings?.bl24}</p>
                  <div className="pwd_mmsy type2">{paragraphsSettings?.bl15}</div>
                  <div className="pwd_text_box type1">
                    <p>{paragraphsSettings?.bl49}</p>
                    <p>{paragraphsSettings?.bl49a}</p>
                  </div>
                  <div className="pwd_text_box type2">
                    <p  dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.bl28,
                    }} />
                  </div>
                  <img src={pwd_type_3_3} alt="" className="type1"/>
                  <img src={pwd_type_3_4} alt="" className="type2"/>
                  <span className="pwd_mima type1">{paragraphsSettings?.bl49b}</span>
                  <div
                    className="pwd_wb_box type1"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.bl27,
                    }}
                  />
                  <div
                    className="pwd_wb_box type2"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.bl29,
                    }}
                  />
                </div>

                <div className={`img_type1 pwd_img3 ${pwdIndex[2] ? 'active' : ''}`} onClick={() => {handleClickPwd(2);}}>
                  <img src={ImgPoint} alt="" className="arrow_icon"
                       style={{display: (pwdStatus === 2 && pwdIndex[2] === false) ? 'block' : 'none'}}
                  />
                  <p className="pwd_title type1">{paragraphsSettings?.bl30}</p>
                  <div className="pwd_mmsy type2">{paragraphsSettings?.bl15}</div>
                  <div className="pwd_text_box type1">
                    <p>{paragraphsSettings?.bl49}</p>
                    <p>{paragraphsSettings?.bl49a}</p>
                  </div>
                  <div className="pwd_text_box type2">
                    <p  dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.bl38,
                    }}></p>
                  </div>
                  <img src={pwd_type_3_3} alt="" className="type1"/>
                  <img src={pwd_type_3_4} alt="" className="type2"/>
                  <span className="pwd_mima type1">{paragraphsSettings?.bl49b}</span>
                  <div
                    className="pwd_wb_box type1"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.bl39,
                    }}
                  />
                  <div
                    className="pwd_wb_box type2"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.bl42,
                    }}
                  />
                </div>

                <div className={`img_type1 pwd_img4 ${pwdIndex[3] ? 'active' : ''}`} onClick={() => {handleClickPwd(3);}}>
                  <img src={ImgPoint} alt="" className="arrow_icon"
                       style={{display: (pwdStatus === 3 && pwdIndex[3] === false) ? 'block' : 'none'}}
                  />
                  <p className="pwd_title type1">{paragraphsSettings?.bl44}</p>
                  <div className="pwd_mmsy type2">{paragraphsSettings?.bl15}</div>
                  <div className="pwd_text_box type1">
                    <p>{paragraphsSettings?.bl49}</p>
                    <p>{paragraphsSettings?.bl49a}</p>
                  </div>
                  <div className="pwd_text_box type2">
                    <p    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.bl46,
                    }}></p>
                  </div>
                  <img src={pwd_type_3_1} alt="" className="type1"/>
                  <img src={pwd_type_3_4_1} alt="" className="type2"/>
                  <span className="pwd_mima type1">{paragraphsSettings?.bl49b}</span>
                  <div
                    className="pwd_wb_box type1"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.bl45,
                    }}
                  />
                  <div
                    className="pwd_wb_box type2"
                    dangerouslySetInnerHTML={{
                      __html: paragraphsSettings?.bl47,
                    }}
                  />
                </div>

              </div>
            </div>
          </div>
          <div className="elebox_5 pc_hide">
            <div className="ele5_top">
               <span
                 className="content"
                 dangerouslySetInnerHTML={{
                   __html: paragraphsSettings?.bl14,
                 }}
               />
              <img src={back_1_3_m} className="img"/>
            </div>
            <div className={`ele_box ${pwdIndex[0] ? 'active' : ''}`}>
              <p className="title type1">{paragraphsSettings?.bl17}</p>
              <p className="title type2">{paragraphsSettings?.bl15}</p>
              <div className="ele_inner" onClick={() => {
                handleClickPwd(0);
              }}>
                <img src={ImgPoint} alt="" className="arrow_icon"
                     style={{display: (pwdStatus === 0 && pwdIndex[0] === false) ? 'block' : 'none'}}
                />
                <div className="left_text type1">
                  <p>{paragraphsSettings?.bl49}</p>
                  <p>{paragraphsSettings?.bl49a}</p>
                </div>
                <div className="left_text type2">
                  <p dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.bl22,
                  }}/>
                </div>
                <div className="right_text1 type1">
                  {paragraphsSettings?.bl20}
                </div>
                <div className="right_text2 type1">
                  {paragraphsSettings?.bl21}
                </div>
                <div className="right_text2 type2"
                     dangerouslySetInnerHTML={{
                       __html: paragraphsSettings?.bl23,
                     }}>
                </div>

                <img src={pwd_type1} className="img_pic type1"/>
                <img src={pwd_type2} className="img_pic type2"/>
              </div>
            </div>

            <div className={`ele_box ${pwdIndex[1] ? 'active' : ''}`}>
              <p className="title type1">{paragraphsSettings?.bl24}</p>
              <p className="title type2">{paragraphsSettings?.bl15}</p>
              <div className="ele_inner" onClick={() => {
                handleClickPwd(1);
              }}>
                <img src={ImgPoint} alt="" className="arrow_icon"
                     style={{display: (pwdStatus === 1 && pwdIndex[1] === false) ? 'block' : 'none'}}
                />
                <div className="left_text type1">
                  <p>{paragraphsSettings?.bl49}</p>
                  <p>{paragraphsSettings?.bl49a}</p>
                </div>
                <div className="left_text type2">
                  <p dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.bl28,
                  }}/>
                </div>
                <div className="right_text1 type1">
                  {paragraphsSettings?.bl20}
                </div>
                <div className="right_text2 type1">
                  {paragraphsSettings?.bl27}
                </div>
                <div className="right_text2 type2"
                     dangerouslySetInnerHTML={{
                       __html: paragraphsSettings?.bl47,
                     }}>
                </div>

                <img src={pwd_type1} className="img_pic type1"/>
                <img src={pwd_type2} className="img_pic type2"/>
              </div>
            </div>
            <div className={`ele_box ${pwdIndex[2] ? 'active' : ''}`}>
              <p className="title type1">{paragraphsSettings?.bl30}</p>
              <p className="title type2">{paragraphsSettings?.bl15}</p>
              <div className="ele_inner" onClick={() => {
                handleClickPwd(2);
              }}>
                <img src={ImgPoint} alt="" className="arrow_icon"
                     style={{display: (pwdStatus === 2 && pwdIndex[2] === false) ? 'block' : 'none'}}
                />
                <div className="left_text type1">
                  <p>{paragraphsSettings?.bl49}</p>
                  <p>{paragraphsSettings?.bl49a}</p>
                </div>
                <div className="left_text type2">
                  <p dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.bl38,
                  }}/>
                </div>
                <div className="right_text1 type1">
                  {paragraphsSettings?.bl20}
                </div>
                <div className="right_text2 type1 fz_14"
                     dangerouslySetInnerHTML={{
                       __html: paragraphsSettings?.bl39,
                     }}
                >
                </div>
                <div className="right_text2 type2"
                     dangerouslySetInnerHTML={{
                       __html: paragraphsSettings?.bl42,
                     }}>
                </div>

                <img src={pwd_type1} className="img_pic type1"/>
                <img src={pwd_type2} className="img_pic type2"/>
              </div>
            </div>
            <div className={`ele_box ${pwdIndex[3] ? 'active' : ''}`}>
              <p className="title type1">{paragraphsSettings?.bl40}</p>
              <p className="title type2">{paragraphsSettings?.bl15}</p>
              <div className="ele_inner" onClick={() => {
                handleClickPwd(3);
              }}>
                <img src={ImgPoint} alt="" className="arrow_icon"
                     style={{display: (pwdStatus === 3 && pwdIndex[3] === false) ? 'block' : 'none'}}
                />
                <div className="left_text type1">
                  <p>{paragraphsSettings?.bl49}</p>
                  <p>{paragraphsSettings?.bl49a}</p>
                </div>
                <div className="left_text type2">
                  <p dangerouslySetInnerHTML={{
                    __html: paragraphsSettings?.bl46,
                  }}/>
                </div>
                <div className="right_text1 type1">
                  {paragraphsSettings?.bl20}
                </div>
                <div className="right_text2 type1"
                     dangerouslySetInnerHTML={{
                       __html: paragraphsSettings?.bl45,
                     }}
                >
                </div>
                <div className="right_text2 type2"
                     dangerouslySetInnerHTML={{
                       __html: paragraphsSettings?.bl47,
                     }}>
                </div>

                <img src={pwd_type1} className="img_pic type1"/>
                <img src={pwd_type2} className="img_pic type2"/>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Section1;
